module.exports = __webpack_public_path__ + "img/hdy_back.7350ce82.png";